import { formatEur } from '@wf/shared'
import type { OverviewKpis } from './overviewMetrics'

function Tile({ label, value, sub, variant }: { label: string; value: string; sub: string; variant?: string }) {
  return (
    <div className={variant ? `wf-stat ${variant}` : 'wf-stat'}>
      <div className="wf-stat__label">{label}</div>
      <div className="wf-stat__value">{value}</div>
      <div className="wf-stat__sub">{sub}</div>
    </div>
  )
}

/**
 * KPI-Kacheln der Chef-Übersicht. Geld-Kacheln (offener Auftragswert, Umsatz) erscheinen NUR mit
 * Abrechnungs-Recht (`showMoney`) — die Rolle sieht nur, was sie auch laden darf. Zähl-Kacheln färben
 * sich nach Dringlichkeit (überfällig/dringend rot bei >0, sonst grün) wie in der Alt-App.
 */
export function KpiTiles({
  kpis,
  showMoney,
  umsatzCents,
  paidCents,
}: {
  kpis: OverviewKpis
  showMoney: boolean
  umsatzCents: number | null
  paidCents: number | null
}) {
  return (
    <div className="wf-kpigrid">
      {showMoney ? (
        <Tile
          label="Offener Auftragswert"
          value={formatEur(kpis.openValueCents)}
          sub={`${kpis.activeCount} aktive Aufträge`}
          variant="wf-stat--accent"
        />
      ) : null}
      {showMoney && umsatzCents != null ? (
        <Tile
          label="Umsatz (Rechnungen)"
          value={formatEur(umsatzCents)}
          sub={paidCents != null ? `davon ${formatEur(paidCents)} bezahlt` : 'festgeschrieben'}
          variant="wf-stat--accent"
        />
      ) : null}
      <Tile
        label="Heute fertig"
        value={String(kpis.doneTodayCount)}
        sub={`${kpis.readyCount} abholbereit`}
        variant="wf-stat--fertig"
      />
      <Tile
        label="Voranschlag offen"
        value={String(kpis.estimateOpenCount)}
        sub="warten auf Kunden"
        variant="wf-stat--arbeit"
      />
      <Tile
        label="Überfällig"
        value={String(kpis.overdueCount)}
        sub="Termin überschritten"
        variant={kpis.overdueCount > 0 ? 'wf-stat--wartet' : 'wf-stat--fertig'}
      />
      <Tile
        label="Dringend (Hoch)"
        value={String(kpis.urgentCount)}
        sub="hohe Priorität"
        variant={kpis.urgentCount > 0 ? 'wf-stat--wartet' : 'wf-stat--fertig'}
      />
    </div>
  )
}
